module.exports = __webpack_public_path__ + "media/shared/PopdownMenu/actions-ca37e4c2edb6efea59282e8c71913a68.svg";